import { useTranslation } from "react-i18next";
import { Button, Icon, List } from "semantic-ui-react";

import { DealerServiceItem } from "modules/CheckInServices/components/DealerServicesList/components";
import { useCheckInServicesQuery } from "modules/CheckInServices/components/DealerServicesList/hooks";
import { useTagsQuery } from "modules/CheckInServices/components/LocationServicesList/hooks";

import type { CheckInService } from "models";

type DealerServicesListProps = {
  onAddService: () => void;
  onServiceClick: (service: CheckInService) => void;
};

export const DealerServicesList = ({ onServiceClick, onAddService }: DealerServicesListProps) => {
  const { t } = useTranslation();

  const { data: dealerServices = [] } = useCheckInServicesQuery();
  const { data: tags = [] } = useTagsQuery();

  return (
    <>
      <div className="services-header">
        <Button icon onClick={onAddService}>
          <Icon className="plus solid" color="green" />
        </Button>
        <h3>{t("v8_dealer_services", "Dealer Services")}</h3>
      </div>
      <div className="services-list-container">
        <List divided relaxed>
          {dealerServices.map(service => (
            <DealerServiceItem key={service.id} service={service} tags={tags} onClick={onServiceClick} />
          ))}
        </List>
      </div>
    </>
  );
};
